import ApiService from "../ApiService";
import RoleService from "../roles/RoleService";
import providerService from "../provider/ProviderService";

const userService = {
    getUser({ page = 1, limit = 20, search = '' }) {
    const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
        search: search || '',
    });
    return ApiService.get(`/user?${params.toString()}`);
    },
    getUserOne(id) {
        return ApiService.get(`/user/${id}`);
    },
    createUser(items) {
        return ApiService.post("/user", items);
    },
    getRoles() {
        return RoleService.getRoles();
    },
    getProviders() {
        return providerService.getProviders();
    },
    updateUsers(id, data) {
        return ApiService.post(`/user/update?id=${id}`, data);
    },
    deleteUsers(data) {
        return ApiService.post(`/user/remove`, data);
    }
};

export default userService;